module.exports = __webpack_public_path__ + "img/toggle-panel-black.20d328b0.svg";